import Vue from 'vue';
import App from './App.vue';
import store from '@/core/services/store';
import router from './router';
import ApiService from '@/core/services/api.service';


Vue.config.productionTip = false;

// Global 3rd party plugins
import 'popper.js';
import 'tooltip.js';
import PerfectScrollbar from 'perfect-scrollbar';
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from 'clipboard';
window.ClipboardJS = ClipboardJS;
// import Num2persian from 'num2persian';
// Vue 3rd party plugins
// import "@/core/plugins/bootstrap-vue";
import i18n from '@/core/plugins/vue-i18n';
import vuetify from '@/core/plugins/vuetify';
// import '@/core/plugins/portal-vue';
// import '@/core/plugins/ckeditor';
import '@/core/plugins/perfect-scrollbar';
import '@/core/plugins/highlight-js';
import '@/core/plugins/inline-svg';
import '@/core/plugins/filter';
// import '@/core/plugins/vue2-dropzone';
import '@/core/plugins/metronic';
import '@/core/plugins/dialogs';
import '@/core/plugins/leaflet';
import '@/core/plugins/base';
import '@mdi/font/css/materialdesignicons.css';
import VueNumber from 'vue-number-animation';
import VueHtmlToPaper from 'vue-html-to-paper';
import ZoomOnHover from 'vue-zoom-on-hover';
import '@/assets/css/style.new.scss';

// Global Registeration Components
import '@/components/commonComponents';
import '@/core/plugins/loading';
import '@/core/plugins/veeValidate';
import '@/core/plugins/tree-select';
import '@/core/plugins/scrollLoader';
import '@/core/plugins/filter';
import '@/core/plugins/num2persian';
import '@/core/plugins/cropper';
import AudioRecorder from 'vue2-audio-recorder';
// import '@/core/plugins/signalR';
var signalR = require('@/core/plugins/signalr.js');

Vue.prototype.$signalR = signalR;
// Vue.use(Num2persian);
Vue.use(VueNumber);
Vue.use(VueHtmlToPaper);
Vue.use(ZoomOnHover);
 Vue.use(AudioRecorder)

// API service init
ApiService.init();

(async () => {
  try {
    let response = await fetch(location.origin + '/config.json', {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });

    let jsonResponse = await response.json();
    store.commit('SET_CONFIG', jsonResponse);
    // if (localStorage.getItem('activeTab')) {
    //   store.dispatch('addTab', JSON.parse(localStorage.getItem('activeTab')));
    // }
  } catch (error) {
    alert(error);
  }

  Vue.config.productionTip = false;
  new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: (h) => h(App),
    mounted() {
      const d = {};
      document.addEventListener('mousedown', (e) => {
        const closestDialog =
          e.target.closest('.v-dialog.v-dialog--active') &&
          e.target
            .closest('.v-dialog.v-dialog--active')
            .closest(':not(.undraggable)');
        if (
          e.button === 0 &&
          closestDialog != null &&
          e.target.classList.contains('v-card__title')
        ) {
          // element which can be used to move element
          d.el = closestDialog; // element which should be moved
          d.mouseStartX = e.clientX;
          d.mouseStartY = e.clientY;
          d.elStartX = d.el.getBoundingClientRect().left;
          d.elStartY = d.el.getBoundingClientRect().top;
          d.el.style.position = 'fixed';
          d.el.style.margin = 0;
          d.oldTransition = d.el.style.transition;
          d.el.style.transition = 'none';
        }
      });
      document.addEventListener('mousemove', (e) => {
        if (d.el === undefined) return;
        d.el.style.left =
          Math.min(
            Math.max(d.elStartX + e.clientX - d.mouseStartX, 0),
            window.innerWidth - d.el.getBoundingClientRect().width
          ) + 'px';
        d.el.style.top =
          Math.min(
            Math.max(d.elStartY + e.clientY - d.mouseStartY, 0),
            window.innerHeight - d.el.getBoundingClientRect().height
          ) + 'px';
      });
      document.addEventListener('mouseup', () => {
        if (d.el === undefined) return;
        d.el.style.transition = d.oldTransition;
        d.el = undefined;
      });
      setInterval(() => {
        // prevent out of bounds
        const dialog = document.querySelector('.v-dialog.v-dialog--active');
        if (dialog === null) return;
        dialog.style.left =
          Math.min(
            parseInt(dialog.style.left),
            window.innerWidth - dialog.getBoundingClientRect().width
          ) + 'px';
        dialog.style.top =
          Math.min(
            parseInt(dialog.style.top),
            window.innerHeight - dialog.getBoundingClientRect().height
          ) + 'px';
      }, 100);
    },
  }).$mount('#app');
})();
